export const ANALYTICS_PAGE_VIEW = 'analyticsPageview'
//creates a page view event
export const ANALYTICS_EVENT = 'analyticsEvent'
//sends click/other events variables on a traditional page
export const ANALYTICS_MODAL_PAGE_VIEW = 'analyticsModalPageview'
//creates a page view for a modal (required because different page variables are set for modals)
export const ANALYTICS_MODAL_EVENT = 'analyticsModalEvent'
//sends click/other events variables on a modal page(required because different page variables are set for modals)
